// feature menus
import menu_features_leesburg from './images/menus/Leesburg/menu_features_leesburg.png'
import menu_features_middleburg from './images/menus/Middleburg/menu_features_middleburg.png'
import menu_features_noma from './images/menus/Noma/menu_features_noma.png'
import menu_features_potomac from './images/menus/Potomac/menu_features_potomac.png'

// event menus
import weddingmenu from './images/menus/events/weddingmenu.png'
import holidaymenu from './images/menus/events/holidaymenu.png'
import birthdaymenu from './images/menus/events/birthdaymenu.png'
import pridemenu from './images/menus/events/pridemenu.png'

// table tents
import oyster_menu_leesburg from './images/menus/Leesburg/oyster_menu_leesburg.png'
import beer_menu_leesburg from './images/menus/Leesburg/beer_menu_leesburg.png'
import happy_hour_menu_leesburg from './images/menus/Leesburg/happy_hour_menu_leesburg.png'
import oyster_menu_middleburg from './images/menus/Middleburg/oyster_menu_middleburg.png'
import beer_menu_middleburg from './images/menus/Middleburg/beer_menu_middleburg.png'
import happy_hour_menu_middleburg from './images/menus/Middleburg/happy_hour_menu_middleburg.png'
import oyster_menu_noma from './images/menus/Noma/oyster_menu_noma.png'
import beer_menu_noma from './images/menus/Noma/beer_menu_noma.png'
import happy_hour_menu_noma from './images/menus/Noma/happy_hour_menu_noma.png'
import oyster_menu_potomac from './images/menus/Potomac/oyster_menu_potomac.png'
import beer_menu_potomac from './images/menus/Potomac/beer_menu_potomac.png'
import happy_hour_menu_potomac from './images/menus/Potomac/happy_hour_menu_potomac.png'

// main menus
import leesburg_brunch_menu from './images/menus/Leesburg/leesburg_brunch_menu.jpg'
import leesburg_cocktail_menu from './images/menus/Leesburg/leesburg_cocktail_menu.jpg'
import leesburg_dinner_menu from './images/menus/Leesburg/leesburg_dinner_menu.jpg'
import middleburg_brunch_menu from './images/menus/Middleburg/middleburg_brunch_menu.jpg'
import middleburg_cocktail_menu from './images/menus/Middleburg/middleburg_cocktail_menu.jpg'
import middleburg_dinner_menu from './images/menus/Middleburg/middleburg_dinner_menu.jpg'
import noma_brunch_menu from './images/menus/Noma/noma_brunch_menu.jpg'
import noma_cocktail_menu from './images/menus/Noma/noma_cocktail_menu.jpg'
import noma_dinner_menu from './images/menus/Noma/noma_dinner_menu.jpg'
import potomac_brunch_menu from './images/menus/Potomac/potomac_brunch_menu.jpg'
import potomac_cocktail_menu from './images/menus/Potomac/potomac_cocktail_menu.jpg'
import potomac_dinner_menu from './images/menus/Potomac/potomac_dinner_menu.jpg'

// fish feature images
import bronzino_tomato_salad from './images/specials/food/bronzino_tomato_salad.jpg'
import halibut_risotto from './images/specials/food/halibut_risotto.jpg'
import halibut_risotto_full from './images/specials/food/halibut_risotto_full.jpg'
import swordfish_shrimp_grits from './images/specials/food/swordfish_shrimp_grits.jpg'
import swordfish_risotto from './images/specials/food/swordfish_risotto.jpg'
import rockfish_jasmine_rice from './images/specials/food/rockfish_jasmine_rice.jpg'
import rockfish_jambalaya from './images/specials/food/rockfish_jambalaya.jpg'
import rainbowTrout from './images/specials/food/rainbowTrout.jpg'
import mahiMahi from './images/specials/food/mahiMahi.jpg'
import stuffedFlounder from './images/specials/food/stuffedFlounder.jpg'
import babyBackRibs from './images/specials/food/babyBackRibs.jpg'

// cocktail feature images
import julep from './images/specials/drink/julep.jpg'
import mango_tango from './images/specials/drink/mango_tango.jpg'
import taybaybay from './images/specials/drink/taybaybay.jpg'
import tikitac from './images/specials/drink/tikitac.jpg'
import taiOneOn from './images/specials/drink/taiOneOn.jpg'
import penicillin from './images/specials/drink/penicillin.jpg'
import beesknees from './images/specials/drink/beesknees.jpg'
import loveLetter from './images/specials/drink/loveLetter.jpg'

// header images
import kingstoysterbar from './images/headers/kingstoysterbar.png'
import logo from './images/headers/logo.png'
import ksobdc2 from './images/headers/ksobdc2.jpg'
import leesburg from './images/headers/leesburg.jpeg'
import middleburg from './images/headers/middleburg.jpg'
import potomac from './images/headers/potomac.jpg'
import dc3 from './images/headers/dc3.jpg'
import pdr from './images/headers/pdr.jpg'
import ksobfood from './images/headers/ksobfood.jpg'
import shuckit from './images/headers/shuckit.jpg'
import oyster from './images/headers/oyster-image.png'
import oysterCard from './images/headers/oysterCard.jpg'

// coming soon
import comingSoonImg from './images/comingSoon/coming-soon-img.jpg'
import comingSoonImgSm from './images/comingSoon/coming-soon-img-mobile.jpg'

//templates
import oyster_menu_template from './images/menus/templates/oyster_menu_template.png'
import oyster_menu_template_noma from './images/menus/templates/oyster_menu_template_noma.png'
import beer_menu_template from './images/menus/templates/beer_menu_template.png'
import feature_sheet_template2 from './images/menus/templates/feature_sheet_template2.png'
import feature_menu_template from './images/menus/templates/feature_menu_template.png'
import happy_hour_menu_leesburg_template from './images/menus/templates/happy_hour_menu_leesburg_template.png'
import happy_hour_menu_middleburg_template from './images/menus/templates/happy_hour_menu_middleburg_template.png'
import happy_hour_menu_noma_template from './images/menus/templates/happy_hour_menu_noma_template.png'
import happy_hour_menu_potomac_template from './images/menus/templates/happy_hour_menu_potomac_template.png'
import allergyOyster from './images/menus/templates/allergyOyster.png'
import food from './images/menus/templates/food.png'
import beer_wine from './images/menus/templates/beer_wine.png'
import bottles from './images/menus/templates/cans&bottles.png'

export default {
    allergyOyster,
    babyBackRibs,
    beer_menu_leesburg,
    beer_menu_middleburg,
    beer_menu_noma,
    beer_menu_potomac,
    beer_menu_template,
    beer_wine,
    beesknees,
    birthdaymenu,
    bottles,
    bronzino_tomato_salad,
    comingSoonImg,
    comingSoonImgSm,
    dc3,
    feature_menu_template,
    feature_sheet_template2,
    food,
    halibut_risotto,
    halibut_risotto_full,
    happy_hour_menu_leesburg,
    happy_hour_menu_leesburg_template,
    happy_hour_menu_middleburg,
    happy_hour_menu_middleburg_template,
    happy_hour_menu_noma,
    happy_hour_menu_noma_template,
    happy_hour_menu_potomac,
    happy_hour_menu_potomac_template,
    holidaymenu,
    julep,
    kingstoysterbar,
    ksobdc2,
    ksobfood,
    leesburg,
    logo,
    loveLetter,
    leesburg_brunch_menu,
    leesburg_cocktail_menu,
    leesburg_dinner_menu,
    mahiMahi,
    middleburg_brunch_menu,
    middleburg_cocktail_menu,
    middleburg_dinner_menu,
    menu_features_leesburg,
    menu_features_middleburg,
    menu_features_noma,
    menu_features_potomac,
    mango_tango,
    middleburg,
    noma_brunch_menu,
    noma_cocktail_menu,
    noma_dinner_menu,
    oyster_menu_template,
    oyster_menu_template_noma,
    oyster,
    oyster_menu_leesburg,
    oysterCard,
    oyster_menu_middleburg,
    oyster_menu_noma,
    oyster_menu_potomac,
    penicillin,
    potomac_brunch_menu,
    potomac_cocktail_menu,
    potomac_dinner_menu,
    pdr,
    potomac,
    pridemenu,
    rainbowTrout,
    rockfish_jasmine_rice,
    rockfish_jambalaya,
    shuckit,
    stuffedFlounder,
    swordfish_shrimp_grits,
    swordfish_risotto,
    taiOneOn,
    taybaybay,
    tikitac,
    weddingmenu,
}